<template>
  <div>
    <el-container>
      <el-main style="padding: 0; display: flex">
        <div style="width: 571px;padding-right: 20px;border-right: 1px solid #e4e7ed;">
          <span>组装开工扫描</span>
          <el-divider/>
          <el-form
              ref="form"
              v-loading="submitLoading"
              style="width: 550px"
              :rules="ruleValidate"
              :model="model"
              class="form"
              label-width="110px"
              @submit.native.prevent>
            <el-form-item label="生产工单" prop="orderNo">
              <el-input
                  ref="orderNoInput"
                  v-model="model.orderNo"
                  placeholder="请扫生产工单号"
                  size="mini"
                  @keyup.enter.native.stop="orderNoScan"/>
            </el-form-item>
            <el-form-item label="组装开工数量" prop="assembleStartQty">
              <el-input
                  v-model="model.assembleStartQty"
                  size="mini"/>
            </el-form-item>
            <el-form-item label="组装线别" prop="assembleLineName">
              <el-select v-model="model.assembleLineName">
                <el-option label="组装线1" value="组装线1"/>
                <el-option label="组装线2" value="组装线2"/>
                <el-option label="组装线3" value="组装线3"/>
              </el-select>
            </el-form-item>
            <el-form-item label="组装工位数量" prop="assembleStationQty">
              <span>{{model.assembleStationQty}}</span>
            </el-form-item>
            <el-button type="primary" @click="submitHandle">开工</el-button>
          </el-form>
          <span>扫描记录</span>
          <el-divider/>
          <el-table
              style="width: 550px"
              border
              stripe
              height="calc(50vh - 286px)"
              :data="confirmationRecord">
            <el-table-column type="index" align="center" label="#"/>
            <el-table-column prop="billNo" align="center" label="订单号"/>
            <el-table-column prop="sn" align="center" label="序列号"/>
            <el-table-column prop="station" align="center" label="工序"/>
            <!--          <el-table-column prop="materialName" align="center" label="创建人"/>-->
            <el-table-column prop="createTime" align="center" label="创建时间"/>
          </el-table>
        </div>
      </el-main>
    </el-container>
    <!-- 订单信息 -->
    <order-infor-comp ref="orderInforComp"/>
  </div>
</template>

<script>
  import OrderInforComp from "./OrderInforComp.vue";
  export default {
    name: "Assembly",
    components: {OrderInforComp},

    data() {
      return {
        submitLoading: false,
        getDataLoading: false,
        complete: false,
        confirmationRecord: [],
        form: {
          routingList: [],
        },
        model: {
          orderNo: "",
          operationNo: "",
          snSerialNo: "",
          assembleStartQty: "",
          assembleLineName: "",
          assembleStationQty: 1,
        },
        ruleValidate: {
          orderNo: [{required: true, message: "请扫描工单号", trigger: "blur"}],
          // operationNo: [{required: true, message: "请选择工序", trigger: "blur"}],
          // snSerialNo: [{required: true, message: "请扫描序列号", trigger: "blur"}],
          assembleStartQty: [{required: true, message: "请输入组装开工数量", trigger: "blur"}],
          assembleLineName: [{required: true, message: "请选择组装线别", trigger: "blur"}],
          assembleStationQty: [{required: true, message: "请输入组装工位数量", trigger: "blur"}],
        },
      };
    },

    methods: {
      orderNoScan() {
        if (this.model.orderNo) {
          this.submitLoading = true;
          this.$http.get("basic", `sapProductionOrders/getByNo/${this.model.orderNo}`).then((res) => {
            if (res.success) {
              if (this.$refs.orderInforComp) {
                this.$refs.orderInforComp.getData(this.model.orderNo);
              }
              this.submitLoading = false;
              this.form = res.data;
              this.model.assembleStartQty = this.form.orderNum;
              this.model.assembleLineName = res.data.scheduleList.filter(item => item.productionLineType === 1)[0].productionLine;
              this.model.assembleStationQty =1;
              this.$playScanSuccess();
            } else {
              this.submitLoading = false;
              this.$refs.form.resetFields();
              this.$playScanFailure();
            }
          }).catch(() => {
            this.submitLoading = false;
          });
        }
      },
      submitHandle() {
        if (this.model.orderNo) {
          this.submitLoading = true;
          let params = {
            billNo: this.model.orderNo,
            // snSerialNo: this.model.snSerialNo.replace(/\s/g, ""),
            assembleStartQty: this.model.assembleStartQty,
            assembleLineName: this.model.assembleLineName,
            assembleStationQty: this.model.assembleStationQty,
          };
          this.$http.post("basic", "sapProductionOrders/confirmAssemble", params).then((res) => {
            if (res.success) {
              this.confirmationRecord = res.data;
              this.submitLoading = false;
              this.$message.success("扫描成功");
              this.$playScanSuccess();
            } else {
              // this.$refs.form.resetFields();
              this.submitLoading = false;
              this.$message.error("扫描失败");
              this.$playScanFailure();
            }
          }).catch(() => {
            this.submitLoading = false;
          });
        }
      },
      processChange() {
        this.$refs.snSerialNoInput.focus();
      },
      snSerialNoChange() {
        this.submitLoading = true;
        if (this.model.orderNo && this.model.operationNo && this.model.snSerialNo) {
          let params = {
            billNo: this.model.orderNo,
            station: this.model.operationNo,
            snSerialNo: this.model.snSerialNo.replace(/\s/g, ""),
            assembleStartQty: this.model.assembleStartQty,
            assembleLineName: this.model.assembleLineName,
            assembleStationQty: this.model.assembleStationQty,
          };
          this.$http.post("basic", "sapProductionOrders/confirmAssemble", params).then((res) => {
            if (res.success) {
              this.confirmationRecord = res.data;
              this.submitLoading = false;
              this.$message.success("扫描成功");
              this.$playScanSuccess();
            } else {
              // this.$refs.form.resetFields();
              this.submitLoading = false;
              this.$message.error("扫描失败");
              this.$playScanFailure();
            }
          }).catch(() => {
            this.submitLoading = false;
          });
        }

      },
    },
  };
</script>
<style scoped lang="scss">
::v-deep .el-container {
  height: 50vh;
}
</style>

